import { render, staticRenderFns } from "./default.vue?vue&type=template&id=2c53281e&scoped=true&"
import script from "./default.vue?vue&type=script&lang=ts&"
export * from "./default.vue?vue&type=script&lang=ts&"
import style0 from "./default.vue?vue&type=style&index=0&id=2c53281e&prod&lang=scss&scoped=true&"
import style1 from "./default.vue?vue&type=style&index=1&id=2c53281e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c53281e",
  null
  
)

export default component.exports